import type { TCredentials, TAuthTokens } from "./types";
import { HTTP } from "@/api/index";
import { type AxiosResponse } from "axios";
import { createService } from "@/api/shared/service";

export * from "./types";

const SLUG = "/auth/jwt";

export default createService(SLUG, {
  async authenticate(credentials: TCredentials): Promise<AxiosResponse<TAuthTokens>> {
    return await HTTP.post<TAuthTokens>(
      `${SLUG}/create/`,
      {
        ...credentials,
      },
      {
        withCredentials: true,
      }
    );
  },

  async refresh(refreshToken: string): Promise<AxiosResponse<TAuthTokens>> {
    return await HTTP.post<TAuthTokens>(
      `${SLUG}/refresh/`,
      {
        refresh: refreshToken,
      },
      {
        withCredentials: true,
      }
    );
  },

  async verify(accessToken: string): Promise<AxiosResponse<TAuthTokens>> {
    return await HTTP.post<TAuthTokens>(`${SLUG}/verify/`, { token: accessToken });
  },
});
